import { render, staticRenderFns } from "./OutOfStockWarning.vue?vue&type=template&id=6785fa1c"
import script from "./OutOfStockWarning.vue?vue&type=script&lang=js"
export * from "./OutOfStockWarning.vue?vue&type=script&lang=js"
import style0 from "./OutOfStockWarning.vue?vue&type=style&index=0&id=6785fa1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports